import classNames from 'classnames';
import { FC, useRef } from 'react';
import { useOnClickOutside } from '../../hooksHelpers';
import { ICalendarEvent } from '../../types';
import EventTooltip from './EventTooltip';

interface IEventButtonProps {
  calEvent: ICalendarEvent;
  selectedEventId: number;
  onEventClick: (eventId: number | null) => void;
}

const EventButton: FC<IEventButtonProps> = ({
  calEvent,
  selectedEventId,
  onEventClick,
}) => {
  return (
    <div className="event-calendar__event-container">
      {calEvent.id === selectedEventId && <EventTooltip calEvent={calEvent} />}

      <div
        onClick={() => onEventClick(calEvent.id)}
        className={classNames('event-calendar__event-btn', {
          'event-calendar__event-btn-active': calEvent.id === selectedEventId,
        })}
      ></div>
    </div>
  );
};

interface IProps {
  events: ICalendarEvent[];
  selectedEventId: number;
  onEventClick: (eventId: number | null) => void;
}

const EventButtons: FC<IProps> = ({
  events,
  onEventClick,
  selectedEventId,
}) => {
  const ref = useRef();

  useOnClickOutside(ref, () => {
    const isTooltipOpenOnThisDay = events.find(
      calEvent => calEvent.id === selectedEventId,
    );
    if (isTooltipOpenOnThisDay) {
      onEventClick(null);
    }
  });

  const sortedEvents = events.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );

  return (
    <div ref={ref}>
      {sortedEvents.map(calEvent => (
        <EventButton
          key={calEvent.id}
          calEvent={calEvent}
          onEventClick={onEventClick}
          selectedEventId={selectedEventId}
        />
      ))}
    </div>
  );
};

export default EventButtons;
